import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Button, NotificationDialog } from '@surfline/quiver-react';
import { color } from '@surfline/quiver-themes';
import { useCookies } from 'react-cookie';
import { getMeterRemaining, getMeter } from '@surfline/web-common';

import config from '../../config';
import { SURF_CHECK_TREATMENT_VARIANT } from '../../common/constants';

const SurfCheckCounter = () => {
  const meterRemaining = useSelector(getMeterRemaining);
  const { treatmentVariant } = useSelector(getMeter);
  const [expanded, setExpanded] = useState(true);
  const [cookies, setCookie] = useCookies(['surf_check_first_page_view']);
  const currentURL = useSelector((state) => state.router.location.pathname);
  const toggleModalType = () => {
    setTimeout(() => {
      setExpanded(!expanded);
    }, 300);
  };
  const handleOnScroll = () => {
    if (expanded) toggleModalType();
  };
  useEffect(() => {
    window.addEventListener('scroll', handleOnScroll);
    return () => {
      // unsubscribe event
      window.removeEventListener('scroll', handleOnScroll);
    };
  });

  useEffect(() => {
    if (!cookies.surf_check_first_page_view) {
      setCookie('surf_check_first_page_view', currentURL, { maxAge: 1800 }); // 30 min
    }
    if (cookies.surf_check_first_page_view === currentURL) {
      setExpanded(true);
    }
  }, [currentURL, cookies, setCookie]);

  const onClickCTA = () => {
    // Track clicked
    setTimeout(() => {
      window.location.assign(`${config.funnelUrl}`);
    }, 500);
  };

  let headerText = meterRemaining > 1 ? 'Views Remaining' : 'View Remaining';
  if (treatmentVariant === SURF_CHECK_TREATMENT_VARIANT) {
    headerText = meterRemaining > 1 ? 'Surf Checks left' : 'Surf Check left';
  }
  const subHeaderText =
    treatmentVariant === SURF_CHECK_TREATMENT_VARIANT
      ? 'Enjoy the extras available in your Free Account. For unlimited Surf Checks & all the best features, upgrade to Premium.'
      : 'Enjoy the extras available in your Free Account. For unlimited access & all the best features, upgrade to Premium.';

  return (
    // eslint-disable-next-line
    <div onClick={onClickCTA} className="sl-meter-verified-modal">
      <NotificationDialog
        title={
          <div className="sl-meter-verified-modal__box-header">
            <div className="sl-meter-verified-modal__count">{meterRemaining}</div>
            <h5 className="sl-meter-verified-modal__box-title">{headerText}</h5>
          </div>
        }
        expanded={expanded}
        bgColor={color('dark-blue', 90)}
      >
        <p className="sl-meter-verified-modal__box-text">{subHeaderText}</p>
        <Button onClick={onClickCTA}>LEARN MORE</Button>
      </NotificationDialog>
    </div>
  );
};

export default SurfCheckCounter;
